import { UserVuetifyPreset } from 'vuetify'
import pl from 'vuetify/src/locale/pl'

const config: Partial<UserVuetifyPreset> = {
    lang: {
        locales: {
            pl
        },
        current: 'pl'
    },
    theme: {
        dark: true,
        options: {
            minifyTheme (css: string): string {
                return process.env.NODE_ENV === 'production'
                    ? css.replace(/[\r\n|\r|\n]/g, '')
                    : css
            }
        },
        themes: {
            dark: {
                faded: {
                    darken4: '#138c5a'
                },
                primary: {
                    base: '#40e2af',
                    lighten5: '#e8fcf5',
                    lighten4: '#c6f6e7',
                    lighten3: '#a0f1d7',
                    lighten2: '#79ebc7',
                    lighten1: '#5de6bb',
                    darken1: '#3adfa8',
                    darken2: '#32da9f',
                    darken3: '#2ad696',
                    darken4: '#1ccf86'
                },
                secondary: {
                    base: '#56acff',
                    lighten5: '#ebf5ff',
                    lighten4: '#cce6ff',
                    lighten3: '#abd6ff',
                    lighten2: '#89c5ff',
                    lighten1: '#6fb8ff',
                    darken1: '#4fa5ff',
                    darken2: '#459bff',
                    darken3: '#3c92ff',
                    darken4: '#2b82ff'
                }
            }
        }
    }
}

export default config
